import React from 'react'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import styles from './KPICard.module.css'

const KPICard = ({
  value,
  label,
  subtext,
  trend,
  trendLabel,
  status,
  icon: Icon,
  loading = false,
  size = 'default',
}) => {
  if (loading) {
    return (
      <div className={`${styles.card} ${styles.loadingCard}`}>
        <div className={`${styles.skeleton} ${styles.skeletonLabel}`} />
        <div className={`${styles.skeleton} ${styles.skeletonValue}`} />
        <div className={`${styles.skeleton} ${styles.skeletonSubtext}`} />
      </div>
    )
  }

  const statusClass = status ? styles[`status_${status}`] : ''
  const sizeClass = size === 'sm' ? styles.cardSm : ''

  const renderTrend = () => {
    if (trend === null || trend === undefined) return null
    const n = parseFloat(trend)
    if (isNaN(n)) return null
    if (n > 0) return <span className={styles.trendUp}><TrendingUp size={11} />{n.toFixed(1)}%</span>
    if (n < 0) return <span className={styles.trendDown}><TrendingDown size={11} />{Math.abs(n).toFixed(1)}%</span>
    return <span className={styles.trendFlat}><Minus size={11} />0%</span>
  }

  return (
    <div className={`${styles.card} ${statusClass} ${sizeClass}`}>
      <div className={styles.cardHeader}>
        {Icon && <Icon size={14} className={styles.headerIcon} />}
        <span className={styles.label}>{label}</span>
      </div>
      <div className={styles.value}>{value ?? '—'}</div>
      {(trend !== null && trend !== undefined) || trendLabel || subtext ? (
        <div className={styles.footer}>
          {renderTrend()}
          {trendLabel && <span className={styles.trendLabel}>{trendLabel}</span>}
          {subtext && <span className={styles.subtext}>{subtext}</span>}
        </div>
      ) : null}
    </div>
  )
}

export default KPICard
